import React from 'react'

const Error500 = () => {
  return (
    <div>Error500</div>
  )
}

export default Error500